// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { MDBCol } from 'mdbreact';
import { connect } from 'react-redux';
import { Field, formValueSelector, change } from 'redux-form';
import InputField from '../../../customFields/InputField';
import { fetchCountries, fetchStatesOfCountry } from '../../../../../../storage/actions/workOrdersActions';
import ReactSelectField from '../../../customFields/ReactSelectField';
import findOption from '../../../../../../utils/addressSection/findOption';
import handlerValidateZipCode from '../../../../../../utils/addressSection/handlerValidateZipCode';

const contractorTaxInformationReduxFormSelector = formValueSelector('contractorTaxInformationReduxForm');

const AddressSection = ({
  selectedState,
  country,
  change,
  fetchCountries,
  fetchStatesOfCountry,
}) => {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  const getStates = async countryId => {
    const newStates = await fetchStatesOfCountry(countryId);
    setStates(newStates);
    if (!newStates.some(item => (
      item.isoCode === selectedState?.value
      || item.isoCode === selectedState?.label
      || item.label === selectedState?.label
    ))) {
      change('contractorTaxInformationReduxForm', 'state', '');
    } else if (!selectedState?.value || selectedState?.label) {
      const newState = findOption(newStates, ['label', 'value'], selectedState?.label, selectedState);
      change('contractorTaxInformationReduxForm', 'state', newState);
    }
  };

  const getCountries = async () => {
    const newCountriesList = await fetchCountries();
    const newCountries = newCountriesList.map(item => ({
      ...item, value: item.isoCode, label: item.name,
    }));
    setCountries(newCountries);
    if (newCountries.length && !country?.value && !country?.label) {
      const newCountry = findOption(newCountries, ['name'], 'United States');
      change('contractorTaxInformationReduxForm', 'country', newCountry);
    } else if (newCountries.length && !country?.value && country?.label) {
      const newCountry = findOption(newCountries, ['name'], country?.label, country);
      change('contractorTaxInformationReduxForm', 'country', newCountry);
    }
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!countries.length) getCountries();
    if (country?.value) getStates(country.value);
  }, [country]);

    return (
        <>
            {['address1', 'address2', 'city', 'zipCode'].map((fieldName, idx) => (
                <div key={idx} className="field_row">
                    <div className="field_name">
                        <label>
                            {fieldName === 'address1'
                                ? 'Address1:'
                                : fieldName === 'address2'
                                    ? 'Address2:'
                                    : fieldName === 'city'
                                        ? 'City:'
                                        : 'Zip:'}
                        </label>
                    </div>
                    <div className="field_block">
                        <Field
                            name={fieldName}
                            component={InputField}
                            type="text"
                            placeholder={
                                fieldName === 'address1'
                                    ? 'Street Address'
                                    : fieldName === 'address2'
                                        ? 'Bldg, Suite, Etc.'
                                        : fieldName === 'city'
                                            ? 'City'
                                            : 'Zip / Postal Code'
                            }
                            required={fieldName !== 'address2'}
                            validate={fieldName === 'zipCode' ? value => handlerValidateZipCode(value, country) : undefined}
                        />
                    </div>
                </div>
            ))}

            <div className="field_row">
                <div className="field_name">
                    <label>State:</label>
                </div>
                <div className="field_block">
                    <Field
                        name="state"
                        component={ReactSelectField}
                        isSearchable
                        placeholder="State"
                        options={states}
                        required
                        customSelectStyleType="white"
                    />
                </div>
            </div>
        </>
    );
};

const mapDispatchToProps = {
  change,
  fetchCountries,
  fetchStatesOfCountry,
};

const mapStateToProps = state => ({
  country: contractorTaxInformationReduxFormSelector(state, 'country'),
  selectedState: contractorTaxInformationReduxFormSelector(state, 'state'),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressSection);
